module.exports = __webpack_public_path__ + "static/media/facebook.bd4cc768.svg";